import { defineComponent, toRefs } from 'vue';
import { updateCompany } from '@/api/company/companyApi';
import { useCompanyForm } from '../../composition/useCompany';
import { useSnackBar } from '@/composition/snackBar';
export default defineComponent({
    name: 'CompanyInfo',
    components: {
        Label: () => import('@/components/form/Label/index.vue')
    },
    props: {
        company: Object,
        loading: Boolean
    },
    setup(props) {
        const { company } = toRefs(props);
        const { form, loading: updateLoading, rules, save } = useCompanyForm(updateCompany, company);
        const { open } = useSnackBar();
        return {
            form,
            updateLoading,
            rules,
            async save() {
                const result = await save();
                if (result > 0) {
                    open({ text: 'Saved successfully.', color: 'success' });
                }
                else {
                    open({ text: 'An error occurred during processing.', color: 'error' });
                }
            }
        };
    }
});
